import { render, staticRenderFns } from "./AuctionWinners.vue?vue&type=template&id=ca887580&lang=pug"
import script from "./AuctionWinners.vue?vue&type=script&lang=ts"
export * from "./AuctionWinners.vue?vue&type=script&lang=ts"
import style0 from "./AuctionWinners.vue?vue&type=style&index=0&id=ca887580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports